import Config, { ReducedCookieStorage } from 'config';
import { useCallback, useEffect } from 'react';

import AuthService from 'services/AuthService';

const useLogoutOnRefreshTokenCloseToExpire = () => {
    const checkToken = useCallback(() => {
        const timestamp = ReducedCookieStorage.getItem('refreshTokenDate');
        if (
            timestamp &&
            Date.now() - +timestamp > Config.application.refreshTokenLifetimeBeforeLogoutDays * 24 * 60 * 60 * 1000
        ) {
            AuthService.cleanCognitoCookies();
            AuthService.logout();
        }
    }, []);

    useEffect(() => {
        checkToken();
        const checkInterval = setInterval(
            checkToken,
            Config.application.checkRefreshTokenExpirationIntervalMin * 60 * 1000,
        );
        return () => clearInterval(checkInterval);
    }, [checkToken]);

    return null;
};

export default useLogoutOnRefreshTokenCloseToExpire;
